import React from "react";
import { Link } from "react-router-dom";


export interface NotFoundPageProps {
  name?: string;
  classes?: string;
}

/** 404 */
export default class NotFoundPage extends React.Component<NotFoundPageProps> {
  static jsClass = "NotFoundPage";
  static defaultProps: Partial<NotFoundPageProps> = {
    name: "mbNotFound",
  };

  render(): React.ReactNode {
    const { classes } = this.props;

    return (
      <section className={["mb-section", classes].filter(Boolean).join(" ")}>
        <div className="container text-center">
          <h1 className="mb-title mb-3">404</h1>
          <p className="mb-label mb-4">
            Esta página no existe (todavía no la hacemos)
          </p>
          <Link className="mb-btn" to="/">
            Volver al inicio
          </Link>
        </div>
      </section>
    );
  }
}
